import { TSummary } from "../../utils/DTO/SummaryDTO";

export const isPrevention = (summary: TSummary) => {
  return summary?.painArea === "prevention";
};

const THIRTY_DAYS_IN_SECONDS = 30 * 24 * 60 * 60;

export const isWithinFirstThirtyDays = (summary: TSummary): boolean => {
  const applicationTimestamps = (summary?.painAreaList || [])
    .map(pa => pa.applicationSubmitted)
    .filter((timestamp): timestamp is number => Boolean(timestamp));
  if (applicationTimestamps.length === 0) return false;
  const earliestApplication = Math.min(...applicationTimestamps);
  return Math.floor(Date.now() / 1000) - earliestApplication < THIRTY_DAYS_IN_SECONDS;
};

export const isMHIPAvailable = (summary: TSummary): boolean => {
  return summary?.availableProducts?.isMHIPAvailable === true;
};

export const shouldHideAddAnotherPainArea = (summary: TSummary): boolean => {
  return isWithinFirstThirtyDays(summary) && !isMHIPAvailable(summary);
};

export type VerificationStatus = "VERIFIED" | "NOT_ELIGIBLE" | "PENDING" | null;

type DashboardComponent =
  | "completedProgramsTile"
  | "programLibrary"
  | "intakeChoosePrograms";

type ComponentPermissions = {
  visible: boolean;
  showNotEligibleModal?: boolean;
};

type VerificationPermissions = Record<DashboardComponent, ComponentPermissions>;

const verificationStatusPermissions: Record<NonNullable<VerificationStatus>, VerificationPermissions> = {
  VERIFIED: {
    completedProgramsTile: { visible: true },
    programLibrary: { visible: true },
    intakeChoosePrograms: { visible: true },
  },
  NOT_ELIGIBLE: {
    completedProgramsTile: { visible: false, showNotEligibleModal: true },
    programLibrary: { visible: false },
    intakeChoosePrograms: { visible: false },
  },
  PENDING: {
    completedProgramsTile: { visible: false },
    programLibrary: { visible: false },
    intakeChoosePrograms: { visible: false },
  },
};

const defaultPermissions: VerificationPermissions = {
  completedProgramsTile: { visible: false },
  programLibrary: { visible: false },
  intakeChoosePrograms: { visible: false },
};

export const getVerificationPermissions = (summary: TSummary): VerificationPermissions => {
  const verificationStatus = summary?.verificationStatus as VerificationStatus;

  if (!verificationStatus || !(verificationStatus in verificationStatusPermissions)) {
    return defaultPermissions;
  }

  return verificationStatusPermissions[verificationStatus];
};
